import { atom } from "recoil";
import { Route } from "routes/utils/types";

export const authorizedRoutesAtom = atom<Route[]>({
  key: "authorizedRoutesAtom",
  default: [],
});
